import Editor from 'react-simple-code-editor';
import Prism from 'prismjs';
import 'prismjs/components/prism-css';
import 'prismjs/plugins/line-numbers/prism-line-numbers';
import 'prismjs/themes/prism.css';
import { useEffect, useState } from 'react';
import './edit-html.scss';

interface Props {
	onChange: (html: string) => void;
	defaultValue: string;
	maxHeight?: string;
}

export default function CustomHTML({
	onChange,
	defaultValue,
	maxHeight = 'none'
}: Props): JSX.Element {
	const [code, setCode] = useState(defaultValue);

	function updateCode(code: string) {
		setCode(code);
	}

	function highlight(code: any) {
		return Prism.highlight(code, Prism.languages.html, 'html').split("\n")
			.map((line, i) => `<span class='editor-line-number'>${i + 1}</span>${line}`)
			.join("\n");
	}

	async function handleBlur() {
		const div = document.createElement('div');
		div.innerHTML = code;
		setCode(div.innerHTML);
	}

	useEffect(() => {
		onChange(code);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [code]);

	return (
		<div className="custom-css-container" style={{
			...(maxHeight === 'none' ? {} : {
				maxHeight,
				overflow: 'auto'
			})
		}}>
			<Editor
				value={code}
				className="style-editor"
				onValueChange={updateCode}
				onBlur={handleBlur}
				highlight={highlight}
				textareaId="codeArea"
				padding={10}
				style={{
					fontFamily: 'Roboto Mono',
					fontSize: 12
				}}
			/>
		</div>
	);
}
